module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "y-select",
    class: {
      disabled: _vm.disabled
    }
  }, [_c('div', {
    staticClass: "y-select-i",
    on: {
      "mouseenter": function($event) {
        _vm.hover = true
      },
      "mouseleave": function($event) {
        _vm.hover = false
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectLabel),
      expression: "selectLabel"
    }],
    ref: "html",
    staticClass: "y-select-input",
    attrs: {
      "type": "text",
      "readOnly": "true",
      "placeholder": "请选择",
      "disabled": !_vm.disabled ? null : 'disabled'
    },
    domProps: {
      "value": _vm._s(_vm.selectLabel)
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return; }
        _vm.clicks($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selectLabel = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ion-chevron-down ion dr"
  }, [_c('y-svg', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.clearable ? !_vm.hover : true),
      expression: "clearable ? !hover : true"
    }],
    class: {
      active: _vm.show
    },
    attrs: {
      "type": "v",
      "width": 12
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.clicks($event)
      }
    }
  }), _vm._v(" "), _c('y-svg', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hover && _vm.clearable),
      expression: "hover && clearable"
    }],
    class: {
      active: _vm.show
    },
    attrs: {
      "type": "x",
      "width": 12
    },
    nativeOn: {
      "click": function($event) {
        _vm.delVaule($event)
      }
    }
  })], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "y-slide-up"
    }
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    ref: "dropdown",
    staticClass: "y-select-dropdown"
  }, [_vm._t("default")], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.9.9.5@vue-loader/lib/template-compiler.js?id=data-v-599a74b7!./~/.9.9.5@vue-loader/lib/selector.js?type=template&index=0!./components/components/select/select.vue
// module id = 472
// module chunks = 27